import { useAppSelector } from '@/store/hooks'
import { selectShouldShowCreateWorkspaceOnboarding } from '@/store/auth/authSelectors'
import CreateWorkspaceModal from '@/components/modals/CreateWorkspaceModal/CreateWorkspaceModal'

// Renders the first-workspace onboarding modal purely as a function of resolved state
// (selectShouldShowCreateWorkspaceOnboarding), instead of it being opened imperatively from
// the auth saga. Because it's reactive, it can never sit over an already-loaded workspace:
// the moment the live workspaces listener delivers a real workspace, the selector flips to
// false and this unmounts — closing the SCD-933 deadlock at the source. canClose stays false
// (a user with zero workspaces must create one), but it's no longer a dead-end.
const OnboardingWorkspaceGate = () => {
    const shouldShow = useAppSelector(selectShouldShowCreateWorkspaceOnboarding)
    if (!shouldShow) return null
    return <CreateWorkspaceModal canClose={false} onClose={() => {}} />
}

export default OnboardingWorkspaceGate
